<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

function processPackButtons() {
    // Busca todos los contenedores de las opciones
    const swatchItems = document.querySelectorAll('.cl-po--swatch-item');

    if (swatchItems.length === 0) {
        return; // Si no existen, espera
    }

    swatchItems.forEach(item => {
        const button = item.querySelector('.cl-po--swatch-button');
        if (!button) return;

        const originalText = button.textContent.trim();

        // --- LÓGICA DE FORMATEO MEJORADA ---
        const regex = /Pack x\d+/; // Busca el patrón "Pack x" seguido de uno o más números
        const match = originalText.match(regex);

        // Se ejecuta si encuentra el patrón y el botón no ha sido formateado aún
        if (match && !button.querySelector('br')) {
            const packLabel = match[0]; // La primera parte (ej. "Pack x4")
            const priceLabel = originalText.replace(packLabel, '').replace('-', '').trim(); // El resto, quitando el guion (si existe) y espacios

            // Reemplaza el HTML con las dos líneas
            button.innerHTML = `${packLabel}<br><span class="pack-price">${priceLabel}</span>`;
        }

        // --- Lógica para "MEJOR OPCIÓN" (sin cambios) ---
        if (originalText.includes('x4')) {
            item.classList.add('best-option-highlight');
        }
    });

    // Detenemos la búsqueda
    clearInterval(checkInterval);
}

const checkInterval = setInterval(processPackButtons, 250);